<template>
  <div>
    <v-row align="center" justify="start">
      <v-col cols="12" sm="6" md="3" xl="2">
        <BusinessEntitiesDropDownList
          v-model="businessEntityId"
          label="Business Entity"
          :clearable="true"
        ></BusinessEntitiesDropDownList>
      </v-col>
      <v-col cols="12" sm="6" md="3" xl="2">
        <v-autocomplete
          v-model="name"
          :items="clientNames"
          item-text="clientName"
          label="Name"
          outlined
          clearable
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="6" md="3" xl="2">
        <InvoiceFrequenciesDropDownList
          :id="invoiceFrequencyId"
          @change="handleInvoiceFrequencyChange"
        ></InvoiceFrequenciesDropDownList>
      </v-col>
      <v-col cols="12" sm="6" md="3" lg="3" xl="2">
        <ThirdPartyPortalsDropDownList
          :id="thirdPartyPortalId"
          :isRequired="false"
          :disabled="false"
          :readonly="false"
          @ThirdPartyPortalIdChange="(newValue) => this.thirdPartyPortalId = newValue"
        ></ThirdPartyPortalsDropDownList>
      </v-col>
      <v-col cols="12" sm="6" md="2">
        <v-switch
          class="my-auto"
          v-model="includeInactive"
          label="Include Inactive"
        ></v-switch>
      </v-col>
    </v-row>
    <v-row justify="end">
      <v-col cols="12" md="6">
        <FilterButtons
          @search="handleSearchClick"
          @clear="handleClearClick"
        ></FilterButtons>
      </v-col>
    </v-row>
    <FilterButtonsSmall
      @search="handleSearchClick"
      @clear="handleClearClick"
    ></FilterButtonsSmall>
  </div>
</template>

<script>
import { mapFields } from '@/vueHelpers/vuex'
import { mapActions } from 'vuex'
import { FilterButtons, FilterButtonsSmall } from '@/components/buttons'
import { BusinessEntitiesDropDownList } from '@/components/businessEntities'
import { InvoiceFrequenciesDropDownList } from '@/components/invoiceFrequencies'
import ThirdPartyPortalsDropDownList from '@/components/clients/ThirdPartyPortalsDropDownList'

export default {
  components: {
    FilterButtons,
    FilterButtonsSmall,
    BusinessEntitiesDropDownList,
    InvoiceFrequenciesDropDownList,
    ThirdPartyPortalsDropDownList
  },
  props: [
    'clientNames'
  ],
  computed: {
    ...mapFields('clientFilters', [
      'businessEntityId',
      'name',
      'active',
      'invoiceFrequencyId',
      'thirdPartyPortalId'
    ]),
    includeInactive: {
      get () {
        return this.active !== true
      },
      set (newValue) {
        this.active = newValue ? null : true
        this.handleSearchClick()
      }
    }
  },
  methods: {
    ...mapActions('clientFilters', [
      'clearFilters'
    ]),
    handleActiveChange (value) {
      this.active = value
    },
    handleSearchClick () {
      this.$emit('search')
    },
    handleInvoiceFrequencyChange (value) {
      this.invoiceFrequencyId = value
    },
    handleClearClick () {
      this.clearFilters()
      this.$emit('clear')
    }
  }
}
</script>
